import PracticeMembersAPI from 'api/PracticeMembersAPI'
import UsersAPI from 'api/UsersAPI'
import Store from '@/store'
import PracticesAPI from 'api/PracticesAPI'

export function buildPracticeStoreUpdates(formData, apiPractice = {}) {
    const updates = { ...apiPractice }

    if (formData.name !== undefined) {
        updates.name = formData.name
    }
    if (formData.email !== undefined) {
        updates.email = formData.email
    }
    if (formData.phone !== undefined) {
        updates.phone = formData.phone
    }
    if (formData.mobilePhone !== undefined) {
        updates.mobilePhone = formData.mobilePhone
    }
    if (formData.isAgreedToSms !== undefined) {
        updates.isAgreedToSms = formData.isAgreedToSms
    }
    if (formData.faxNumber !== undefined) {
        updates.fax = formData.faxNumber
    }
    if (formData.fax !== undefined) {
        updates.fax = formData.fax
    }

    return updates
}

export function applyPracticeUpdateToStore(updates) {
    if (!updates || typeof updates !== 'object') {
        return
    }

    const practice = Store.getters['auth/getPractice']
    Store.dispatch('auth/setPractice', { ...practice, ...updates })

    if (!updates.name) {
        return
    }

    const members = Store.getters['auth/getMembers']
    if (!members.length) {
        return
    }

    Store.dispatch(
        'auth/setMembers',
        members.map((member) => (member.practice ? { ...member, practice: { ...member.practice, name: updates.name } } : member)),
    )
}

export function applyUserUpdateToStore(userId, updates) {
    if (!updates) {
        return
    }

    const id = parseInt(userId)
    const user = Store.getters['auth/getUser']

    if (parseInt(user.id) === id) {
        Store.dispatch('auth/setUser', { ...user, ...updates })
    }

    const members = Store.getters['auth/getMembers']
    if (members.length) {
        Store.dispatch(
            'auth/setMembers',
            members.map((member) => (parseInt(member.id) === id ? { ...member, ...updates } : member)),
        )
    }
}

export function updateStoreMembers(input) {
    const practiceId = Store.getters['auth/getPractice']?.id || Store.getters['auth/getUser']?.practiceId
    return PracticeMembersAPI.getList(practiceId, { limit: 50, offset: 0 })
        .then((members) => Store.dispatch('auth/setMembers', members))
        .then(() => input)
        .catch(() => Promise.resolve(input))
}

export function updateCurrentUser() {
    return UsersAPI.getCurrent().then((user) => Store.dispatch('auth/setUser', user))
}

export function updateCurrentPractice() {
    return PracticesAPI.getMy().then((practice) => {
        Store.dispatch('auth/setPractice', practice)
    })
}
